var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNodataIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fleet-alert-settings",
    transform: "translate(-717.000000, -196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(717.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00142D",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-1445",
    transform: "translate(4.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9717,9.6281 C15.2717,7.9281 13.0117,6.9911 10.6087,6.9911 L10.6057,6.9911 C8.2027,6.9921 5.9437,7.9291 4.2437,9.6281 L2.8297,8.2141 C4.9067,6.1371 7.6677,4.9921 10.6057,4.9911 L10.6087,4.9911 C13.5457,4.9911 16.3077,6.1361 18.3857,8.2141 L16.9717,9.6281 Z",
    id: "Fill-2055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.414,5.8 L0,4.386 C5.849,-1.462 15.365,-1.462 21.214,4.386 L19.8,5.8 C14.73,0.731 6.483,0.733 1.414,5.8",
    id: "Fill-2056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0713,13.4553 L5.6573,12.0413 C8.3883,9.3123 12.8303,9.3123 15.5573,12.0413 L14.1433,13.4553 C12.1953,11.5093 9.0213,11.5073 7.0713,13.4553",
    id: "Fill-2057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9717,9.6281 C15.2727,7.9291 13.0127,6.9921 10.6097,6.9911 L10.6077,6.9911 C8.2037,6.9911 5.9447,7.9281 4.2437,9.6281 L2.8297,8.2141 C4.9077,6.1361 7.6697,4.9911 10.6077,4.9911 L10.6107,4.9911 C13.5477,4.9921 16.3097,6.1371 18.3857,8.2141 L16.9717,9.6281 Z",
    id: "Fill-2058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1435,13.4553 C12.1945,11.5083 9.0205,11.5083 7.0715,13.4553 L5.6575,12.0413 C8.3875,9.3123 12.8275,9.3123 15.5575,12.0413 L14.1435,13.4553 Z",
    id: "Fill-2059"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNodataIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nodata_icon.ef135cd36cf3e6e77aa46125a4d83d52.svg";